<div *ngIf="graphDataInfo$ | async as graphDataInfo" class="flex flex-col lg:flex-row">
  <div class="flex-1">
    <a routerLink="../" class="text-blue-500 text-xl pl-2 pt-1"><- Back</a>
    <div class="p-2 flex flex-col lg:flex-row justify-between">
      <div class="flex flex-col lg:flex-row">
        <mat-form-field>
          <mat-label>Region</mat-label>
          <mat-select [value]="graphDataInfo.regionId" (selectionChange)="setRegion($event.value)" #regionSelector>
            <mat-option
              *ngFor="let region of (regions$ | async)?.regions; trackBy: 'id' | trackByKey"
              [value]="region.id"
            >
              {{ region.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="lg:ml-2">
          <mat-label>Time Span</mat-label>
          <mat-select
            [value]="graphDataInfo.daysToLookAhead"
            (selectionChange)="setDaysToLookAhead($event.value)"
            #daysToLookAheadSelector
          >
            <mat-option [value]="1"> 1 Day </mat-option>
            <mat-option [value]="3"> 3 Days </mat-option>
            <mat-option [value]="7"> 1 Week </mat-option>
            <mat-option [value]="14"> 2 Weeks </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div *ngIf="graphData$ | async as graphData">
        <button
          *ngIf="graphData.isPossible; else notPossible"
          mat-raised-button
          color="primary"
          [disabled]="graphDataInfo.lastUpdatedBy !== 'calculation'"
          (click)="saveData()"
        >
          Save
        </button>
        <ng-template #notPossible>
          <div class="font-bold text-red-500 flex items-center justify-center p-2" *ngIf="!graphData.isPossible">
            This Configuration is Not Possible
          </div>
        </ng-template>
      </div>
    </div>
    <lohi-revenue-allocation-graph></lohi-revenue-allocation-graph>
    <mat-progress-bar mode="indeterminate" *ngIf="graphDataInfo.lastUpdatedBy === 'local'"></mat-progress-bar>
    <div class="mt-3 border border-gray-400 p-2 m-1 lg:ml-2" *ngIf="graphData$ | async as graphData">
      <span class="text-xl font-bold">{{ $any(regionSelector.selected)?.viewValue }}</span>
      <div class="grid grid-cols-1 lg:grid-cols-3 gap-1">
        <div>Timespan {{ $any(daysToLookAheadSelector.selected)?.viewValue }}</div>
        <div></div>
        <div>
          <div class="flex items-center">Projected: {{ graphData.projectedLoads | number }} loads</div>
          <div [class.text-red-500]="graphData.validForLoadCount > graphData.projectedLoads" class="flex items-center">
            Valid For:
            {{ graphData.validForLoadCount | number }} loads
            <mat-icon class="ml-1" *ngIf="graphData.validForLoadCount > graphData.projectedLoads">error</mat-icon>
          </div>
        </div>
        <div>
          <div>Total Revenue Estimated</div>
          <div>$?</div>
        </div>
        <div>
          <div>Earnings / Driver Shift</div>
          <div>$?</div>
        </div>
      </div>
      <div class="font-bold text-red-500 flex items-center justify-center p-2" *ngIf="!graphData.isPossible">
        This Configuration is Not Possible
      </div>
    </div>
  </div>
  <div
    class="w-full lg:w-1/4 p-1 overflow-y-auto mt-3"
    style="max-height: calc(100vh - 144px)"
    *ngIf="items$ | async as items"
  >
    <div class="text-xl font-bold pb-1">Carriers</div>
    <div class="grid grid-cols-3" *ngIf="filter$$ | async as filter">
      <button class="flex-1 bg-transparent" [class.bg-blue-300]="filter === 'ALL'" (click)="filter$$.next('ALL')">
        All
      </button>
      <button
        class="flex-1 bg-transparent"
        [class.bg-blue-300]="filter === 'PRIORITY'"
        (click)="filter$$.next('PRIORITY')"
      >
        Priority
      </button>
      <button
        class="flex-1 bg-transparent"
        [class.bg-blue-300]="filter === 'FLOATING'"
        (click)="filter$$.next('FLOATING')"
      >
        Floating
      </button>
    </div>
    <mat-form-field class="w-full">
      <mat-label>Search</mat-label>
      <input matInput [formControl]="searchForm" autocomplete="off" />
    </mat-form-field>
    <div class="flex flex-col mb-4" *ngFor="let item of items; trackBy: 'id' | trackByKey">
      <div class="flex justify-between">
        <div class="font-bold">{{ item.name }}</div>
        <mat-checkbox
          #isPriority
          [checked]="item.isPriority"
          labelPosition="before"
          (change)="maybeUnprioritize(item.id, $event.checked)"
          >Target</mat-checkbox
        >
      </div>
      <div class="flex items-center justify-between">
        <div>Earnings Target</div>
        <mat-form-field style="text-align: right">
          <div matPrefix>$</div>
          <input
            matInput
            [value]="item.current / 100"
            [disabled]="!isPriority.checked"
            autocomplete="off"
            (input)="setTarget(item.id, +$event.target.value)"
          />
        </mat-form-field>
      </div>
      <div class="flex items-center justify-between">
        <div>Past 1 Week</div>
        <div class="text-right">{{ item.previous | currencyInPennies }}</div>
      </div>
      <div class="flex items-center justify-between">
        <div>Next 1 Week (Est)</div>
        <div
          class="text-right"
          [class.text-red-500]="item.expectedEarnings < item.previous"
          [class.text-green-500]="item.expectedEarnings > item.previous"
        >
          <ng-container *ngIf="item.expectedEarnings > item.previous">&#9650;</ng-container>
          <ng-container *ngIf="item.expectedEarnings < item.previous">&#9660;</ng-container>
          {{ item.expectedEarnings | currencyInPennies }}
        </div>
      </div>
    </div>
  </div>
</div>
